var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLuontoporttiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 46,
    viewBox: "0 0 172 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.347,24.164C23.19,35.6,12.427,45.5,12.427,45.5c10.066-2.032,16.329-13.773,16.329-22.8,0-9.163-6.307-12.681-6.307-12.681S14.305,14.618,18.347,24.164Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.457,2.547a3.69,3.69,0,1,1-6.549,3.4,3.69,3.69,0,1,1,6.549-3.4Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.787,8.744A2.973,2.973,0,1,1,7.758,7.419,3,3,0,0,1,11.787,8.744Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.866,18.113a2.279,2.279,0,0,1-.961,3.072,2.3,2.3,0,0,1-2.1-4.087A2.275,2.275,0,0,1,5.866,18.113Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.072,26.916a1.538,1.538,0,1,1-2.079-.7A1.547,1.547,0,0,1,4.072,26.916Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.923,45.5s8.953-10.949,6.569-17.477c-2.357-6.455-3.272-9.852-1.644-15.414-7.685,9.548-7.8,15.4-7.8,20.1A30.029,30.029,0,0,0,9.923,45.5Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.659,29.75h6.7a.983.983,0,1,1,0,1.965h-7.7a.942.942,0,0,1-.943-.983v-17.5c0-.642.3-.979.943-.979.7,0,1,.337,1,1.01Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.057,26.164A4.029,4.029,0,0,0,52.09,30.3a4.078,4.078,0,0,0,4.092-4.138v-6.5c0-.644.273-.98.91-.98.666,0,.942.336.942.98V30.854c0,.582-.276.861-.942.861-.637,0-.91-.279-.91-.861V29.568A4.267,4.267,0,0,1,52.09,32.2c-3.638,0-5.912-2.574-5.912-6.56V19.665c0-.674.274-.98.912-.98a.857.857,0,0,1,.967.98Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.671,25.121A4.942,4.942,0,1,0,66.58,20.1,4.964,4.964,0,0,0,61.671,25.121Zm11.763,0a6.851,6.851,0,0,1-6.854,6.867,6.883,6.883,0,1,1,6.854-6.867Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.19,20.77a4.216,4.216,0,0,1,4.031-2.547c3.671,0,5.944,2.484,5.944,6.5v6.069c0,.615-.274.923-.939.923-.638,0-.909-.308-.909-.923V24.2a4.171,4.171,0,0,0-4.1-4.106A4.078,4.078,0,0,0,77.19,24.2v6.624c0,.581-.333.889-.969.889s-.909-.308-.909-.889V19.636c0-.646.271-.951.909-.951a.848.848,0,0,1,.969.951Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.955,18.685V15.5c0-.646.3-.95.969-.95a.859.859,0,0,1,.97.95v3.188h1.912c.608,0,.937.275.937.828s-.329.829-.937.829H91.894V30.826c0,.61-.362.889-.97.889-.666,0-.969-.279-.969-.889V20.342H88.2c-.546,0-.786-.278-.786-.829s.24-.828.786-.828Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.26,25.121a4.942,4.942,0,1,0,4.911-5.025A4.965,4.965,0,0,0,96.26,25.121Zm11.761,0a6.85,6.85,0,0,1-6.85,6.867,6.883,6.883,0,1,1,6.85-6.867Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111.721,21.567h4.218a3.679,3.679,0,0,0,0-7.358h-4.218Zm4.183-9.318a5.655,5.655,0,0,1,0,11.31h-4.183V30.7c0,.675-.3,1.014-.969,1.014a.883.883,0,0,1-.971-1.014V13.594a1.168,1.168,0,0,1,1.332-1.345Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.06,25.121a4.942,4.942,0,1,0,4.913-5.025A4.965,4.965,0,0,0,123.06,25.121Zm11.763,0a6.85,6.85,0,0,1-6.85,6.867,6.883,6.883,0,1,1,6.85-6.867Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138.552,20.5a3.8,3.8,0,0,1,3.517-2.272c1.3,0,3.665.861,3.665,2a1.066,1.066,0,0,1-1,1.07c-.391,0-.727-.4-1.033-.609a2.859,2.859,0,0,0-1.633-.584,3.5,3.5,0,0,0-3.517,3.555v7.111a.829.829,0,0,1-.941.953c-.634,0-.909-.308-.909-.953v-11.1c0-.644.275-.98.909-.98s.941.336.941.98Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.616,18.685V15.5c0-.646.3-.95.969-.95a.86.86,0,0,1,.97.95v3.188h1.909c.61,0,.94.275.94.828s-.33.829-.94.829h-1.909V30.826c0,.61-.364.889-.97.889-.667,0-.969-.279-.969-.889V20.342h-1.76c-.545,0-.787-.278-.787-.829s.242-.828.787-.828Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.166,18.685V15.5c0-.646.3-.95.969-.95a.859.859,0,0,1,.97.95v3.188h1.911c.606,0,.941.275.941.828s-.335.829-.941.829H158.1V30.826c0,.61-.363.889-.97.889-.667,0-.969-.279-.969-.889V20.342h-1.757c-.549,0-.789-.278-.789-.829s.24-.828.789-.828Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M164.046,30.826c0,.61-.334.889-.939.889-.666,0-.939-.279-.939-.889V19.665c0-.644.273-.98.907-.98a.87.87,0,0,1,.971.98Zm.334-16.217a1.231,1.231,0,0,1-1.211,1.282,1.158,1.158,0,0,1-1.244-1.282,1.183,1.183,0,0,1,1.244-1.258A1.268,1.268,0,0,1,164.38,14.609Z",
    fill: "#48b31b",
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 46,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuontoporttiLogo);
export default __webpack_public_path__ + "static/media/luontoportti-logo.821b8813.svg";
export { ForwardRef as ReactComponent };